export const PROB_GIFT_API = {
  home: '/live/gift/prob_gift_act_home',
  rank: '/live/gift/prob_gift_act_rank',
  task: '/live/gift/prob_gift_act_task',
  lucky: '/live/gift/prob_gift_act_lucky',
  scoreDetail: '/live/gift/prob_gift_act_score_detail',
  openChest: '/live/gift/prob_gift_act_open_chest',
} as const

export const PROB_GIFT_VISIT_KEY_PREFIX = 'prob_gift_act_visit_'

export const PROB_GIFT_RANK_PAGE_SIZE = 20

export const PROB_GIFT_SCORE_DETAIL_PAGE_SIZE = 20

/** ProbGiftActRoomPendantUpdate — 入池成功后推送，活动页仅取 prize_pool */
export const PROB_GIFT_PENDANT_UPDATE_SUB_TYPE = 420
